// =============================================
// workspaceTheme.ts — kolory + ikony per workspace
// =============================================
// Single source of truth dla UI workspace switcher + modal.
// Spojne z useWorkspace.tsx WORKSPACES array (ten sam set ID).
//
// Wynies tutaj zeby:
//   - oba komponenty (WorkspaceSwitcher + WorkspaceSwitchDialog) importowaly z 1 miejsca (DRY)
//   - latwiej dodac 3-ci workspace gdy ruszy temat per-user permissions z DOCS/IDEAS.md
//
// NIE ruszamy useWorkspace.tsx (ZERO zmian w logice hook'a) — tu tylko UI styling.
// =============================================

import type { LucideIcon } from "lucide-react";
import { Building2, Palette } from "lucide-react";
import type { Workspace } from "@/hooks/useWorkspace";

export interface WorkspaceTheme {
  /** Hex color — border-left karty sidebar, kolor nazwy workspace, bg buttona "Przełącz na X" */
  accent: string;
  /** Dark tint hex — bg aktywnej karty w modal (kontrast vs accent dla czytelnosci tekstu) */
  bg100: string;
  /** Dark text hex — kontrast vs accent dla buttona "Przełącz" (jasny bg + ciemny text) */
  dark: string;
}

export const WORKSPACE_COLORS: Record<Workspace, WorkspaceTheme> = {
  firma:        { accent: "#85B7EB", bg100: "#1a2a40", dark: "#0d1b2e" },
  sideprojects: { accent: "#ED93B1", bg100: "#3a1a28", dark: "#2a1422" },
};

export const WORKSPACE_ICONS: Record<Workspace, LucideIcon> = {
  firma:        Building2,
  sideprojects: Palette,
};

/**
 * Jednowyrazowa nazwa workspace dla UI (zastepuje full label z useWorkspace.tsx
 * gdy potrzeba krotszej etykiety w karcie sidebar + modal kartach).
 *
 * Konwencja: PascalCase ("Firma" / "SideProjects"). Full label z useWorkspace
 * ("Firma / Zaplecżówki" / "Sponsoraki / Sideprojects") zostaje uzywany tylko
 * w description / tooltips.
 */
export const WORKSPACE_SHORT_NAMES: Record<Workspace, string> = {
  firma:        "Firma",
  sideprojects: "SideProjects",
};
